(() => {
  'use strict';
  const close = (root,focus=false) => {
    const button=root.querySelector('[data-neb-returns-toggle]');
    root.querySelector('.neb-returns__note').hidden=true;
    button.setAttribute('aria-expanded','false');
    if(focus)button.focus({preventScroll:true});
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-neb-returns-toggle]');
    document.querySelectorAll('[data-neb-returns]').forEach(root=>{
      if(button&&root.contains(button)){
        const note=root.querySelector('.neb-returns__note');
        const open=note.hidden;note.hidden=!open;button.setAttribute('aria-expanded',String(open));
        note.classList.remove('is-below');
        if(open&&note.getBoundingClientRect().top<12)note.classList.add('is-below');
      }else if(!root.contains(event.target))close(root);
    });
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape')document.querySelectorAll('[data-neb-returns-toggle][aria-expanded=true]').forEach(button=>close(button.closest('[data-neb-returns]'),true));
  });
})();
